// Fotografías reales de la Clínica Podológica Lorena Cuevas (assets subidos).
const BASE = "https://customer-assets-eiarnc6j.emergentagent.net/job_consent-manager-32/artifacts";

export const IMG = {
  recepcion: `${BASE}/436mmmtx_LorenaCuevas_82.webp`,          // Lorena en recepción (bata blanca)
  retrato: `${BASE}/lt1eqi2i_LorenaCuevas_51.webp`,            // Retrato profesional
  salaEspera: `${BASE}/yoc9g0ts_LorenaCuevas_112.webp`,        // Sala de espera
  estudioBiomecanico: `${BASE}/t1j3j8fo_LorenaCuevas_38.webp`, // Estudio biomecánico (goniómetro)
  quiropodia: `${BASE}/py4inde5_LorenaCuevas_57.webp`,         // Quiropodia con instrumental
  informe: `${BASE}/tlvrdkww_LorenaCuevas_91.webp`,            // Redactando análisis de la carrera
  movilizacion: `${BASE}/f9dbz9og_LorenaCuevas_70.webp`,       // Exploración/movilización del pie
  movilizacion2: `${BASE}/0b7824oa_LorenaCuevas_74.webp`,      // Exploración del pie (detalle)
  sillon: `${BASE}/swtg0e0q_LorenaCuevas_18.webp`,             // Sillón podológico
  gabinete: `${BASE}/xzs30ao5_LorenaCuevas_20.webp`,           // Gabinete de tratamiento
  fachada: `${BASE}/3xd4zzij_LorenaCuevas.webp`,               // Fachada exterior con rótulo
  branding: `${BASE}/sps6e954_LorenaCuevas_2.webp`,            // Tarjeta de visita y estatuilla
  detalleFloral: `${BASE}/coou0ahd_LorenaCuevas_6.webp`,       // Detalle decorativo con flores
  gabineteDetalle: `${BASE}/v6k554qx_LorenaCuevas_13.webp`,    // Gabinete con instrumental estéril
};

export const GALLERY_CATS = [
  { id: "todos", label: "Todo" },
  { id: "profesional", label: "Profesional" },
  { id: "espacio", label: "Espacio" },
  { id: "tratamientos", label: "Tratamientos" },
  { id: "equipamiento", label: "Equipamiento" },
];

export const GALLERY = [
  { src: IMG.fachada, cat: "espacio", alt: "Fachada de la Clínica Podológica Lorena Cuevas" },
  { src: IMG.retrato, cat: "profesional", alt: "Lorena Cuevas, podóloga colegiada" },
  { src: IMG.recepcion, cat: "profesional", alt: "Lorena Cuevas en la recepción de la clínica" },
  { src: IMG.salaEspera, cat: "espacio", alt: "Sala de espera de la clínica podológica" },
  { src: IMG.estudioBiomecanico, cat: "tratamientos", alt: "Estudio biomecánico de la pisada con goniómetro" },
  { src: IMG.gabinete, cat: "espacio", alt: "Gabinete de tratamiento podológico" },
  { src: IMG.informe, cat: "profesional", alt: "Elaboración del informe de análisis de la pisada" },
  { src: IMG.movilizacion, cat: "tratamientos", alt: "Exploración y movilización del pie" },
  { src: IMG.quiropodia, cat: "equipamiento", alt: "Material e instrumental podológico especializado" },
  { src: IMG.branding, cat: "profesional", alt: "Tarjeta de visita de Lorena Cuevas, colegiada nº 1488" },
  { src: IMG.movilizacion2, cat: "tratamientos", alt: "Valoración manual del pie del paciente" },
  { src: IMG.sillon, cat: "equipamiento", alt: "Sillón podológico de la clínica" },
  { src: IMG.detalleFloral, cat: "espacio", alt: "Detalle decorativo de la sala de la clínica" },
  { src: IMG.gabineteDetalle, cat: "equipamiento", alt: "Instrumental estéril y equipamiento del gabinete" },
];
